import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import * as types from "@/store/types";
import * as calendarTypes from "@calendar/store/types";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { sendMessageEventToChild } from "@microsoft/teams-js";
@Component({
    name: "NodeItem",
    computed: {
        ...mapGetters({
            getCalendarFolder: calendarTypes.FOLDER_LIST_TREE,
        }),
    },
    methods: {
        ...mapActions({
            selectCalendarFolder: calendarTypes.FOLDER_SELECT,
        }),
        ...mapMutations({
            setShowSidebar: types.SIDEBAR_VISIBLE,
            setCurrentPage: types.CURRENT_PAGE,
            setCurrentMenu: types.CURRENT_MENU,
        }),
    },
})
export default class NodeItem extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: String }) name!: string;
    @Prop({ type: String }) moduleName!: string;
    @Prop({ type: Array, default: () => [] }) child!: Array<any>;
    @Prop({ type: Object, default: () => null }) menu!: any;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    checked: boolean = false;
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    getCalendarFolder!: any;

    get workflowId() {
        let dqn = this.menu.targetUrl.split("dqn=");
        let targetId = "";
        if (dqn[1]) {
            targetId = dqn[1];
        } else {
            targetId = this.menu.id;
        }
        return targetId;
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    selectCalendarFolder!: (folder: calendar.Folder) => void;

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    setShowSidebar!: (show: boolean) => void;
    setCurrentPage!: (page: object) => void;
    setCurrentMenu!: (name: string) => void;

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Watch("getCalendarFolder.mylist", { deep: true })
    onChangedChecked(newValue: any) {
        if (this.menu.folder) this.checked = newValue.checkedIdxArray.includes(this.menu.folder.index);
    }
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    menuClick() {
        if (this.menu.id && this.menu.path === "workflow-list") {
            let dqn = this.menu.targetUrl.split("dqn=");
            let targetId = "";
            if (dqn[1]) {
                targetId = dqn[1];
            } else {
                targetId = this.menu.id;
            }
            this.setCurrentPage(this.menu);
            this.setCurrentMenu(this.moduleName);
            if (this.menu.type === "router-link") {
                this.setShowSidebar(false);
                this.$router.push({ name: this.menu.path, query: { id: targetId } }).catch(() => {});
            }
        } else {
            this.setCurrentPage(this.menu);
            this.setCurrentMenu(this.moduleName);
            if (this.menu.type === "router-link") {
                this.setShowSidebar(false);
                this.$router.push({ name: this.menu.path, query: { id: this.menu.id } }).catch(() => {});
            }

            if (this.menu.folder) {
                this.selectCalendarFolder(this.menu.folder);
            }
        }
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        if (this.menu.folder) this.checked = this.getCalendarFolder.mylist.checkedIdxArray.includes(this.menu.folder.index);
    }
}
